module.exports = __webpack_public_path__ + "static/media/Paul-Hastings.8d514d2e.jpg";